// eslint-disable-next-line import/prefer-default-export
export const getCampaignsState = (state) => state.campaigns;
